import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useDashboardSummary(from: string, to: string) {
  return useQuery({
    queryKey: ["reporting", "dashboard", from, to],
    queryFn: async () => {
      const res = await api.get("/v1/reporting/dashboard", { from, to });
      if (!res.ok) throw new Error("Failed to fetch dashboard summary");
      return res.json();
    },
  });
}

export function useTimeSeries(
  from: string,
  to: string,
  granularity: "hour" | "day" | "week" | "month" = "day",
) {
  return useQuery({
    queryKey: ["reporting", "timeseries", from, to, granularity],
    queryFn: async () => {
      const res = await api.get("/v1/reporting/timeseries", { from, to, granularity });
      if (!res.ok) throw new Error("Failed to fetch time series");
      return res.json();
    },
  });
}

interface PerformanceParams {
  from: string;
  to: string;
  columns?: string[];
  filters?: Record<string, string | number>;
  orderBy?: string;
  orderDir?: "asc" | "desc";
  limit?: number;
  offset?: number;
}

export function usePerformanceReport(params: PerformanceParams) {
  return useQuery({
    queryKey: ["reporting", "performance", params],
    queryFn: async () => {
      const res = await api.post("/v1/reporting/performance", params);
      if (!res.ok) throw new Error("Failed to fetch performance report");
      return res.json();
    },
  });
}
